import styled from 'styled-components';

export const StyledLeftBar = styled.div<{
  index: number;
  cardInView: number;
  accentColor: string;
  prevColor: string;
}>`
  // this color belongs to new ui system
  background-color: #d9d9d9;
  border-radius: 4px;

  ::after {
    content: '';
    width: 100%;
    height: 25%;
    position: absolute;
    transition: 0.6s;
    top: ${({ index, cardInView }) =>
      cardInView >= index ? index * 25 : (index - 1) * 25}%;
    background-color: ${({ accentColor, prevColor, cardInView, index }) =>
      cardInView >= index ? accentColor : prevColor};
  }
`;

export const StyledImage = styled.div`
  width: 320px;
  height: 260px;
`;
